import { render } from "./payment-method.vue?vue&type=template&id=053c2f08&scoped=true"
import script from "./payment-method.vue?vue&type=script&lang=js"
export * from "./payment-method.vue?vue&type=script&lang=js"

import "./payment-method.vue?vue&type=style&index=0&id=053c2f08&scoped=true&lang=css"

import exportComponent from "/Users/a2019/Documents/Project/MiniApp/miniapp_wing/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-053c2f08"]])

export default __exports__